import React from 'react';
import classnames from 'classnames';
import { withTranslation, WithTranslation } from 'react-i18next';
import { PapiUser } from '@wix/da-papi-types';
import { ResourceType } from '@wix/da-shared-react/pkg/types/resource';
import { BIEventData } from '@wix/da-bi/pkg/types';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import GroupCard from '@wix/da-shared-react/pkg/GroupCard';
import Button from '@wix/da-shared-react/pkg/Button';
import ElementQueries from '@wix/da-shared-react/pkg/ElementQueries';

import s from './Groups.scss';

export interface Group {
  username: string;
  usericon: string;
}

export interface Props {
  moduleId: number;
  profileOwnerUser: PapiUser;
  type: 'member' | 'admin';
  isOwner: boolean;
  isWide: boolean;
  seeAllUrl: string;
  browseUrl: string;
  username: string;
  groups: Group[];
  isHeaderStickyOnMobile?: boolean;
  canLoadMore?: boolean;
}

export class Groups extends React.Component<Props & WithTranslation> {
  render() {
    const { canLoadMore, t } = this.props;

    return (
      <>
        {this.renderGrid()}
        {canLoadMore && (
          <Button view="b8" className={s['load-more-button']}>
            {t!('widgets.groups.loadMore')}
          </Button>
        )}
      </>
    );
  }

  renderGrid() {
    const { isWide, groups } = this.props;
    const elements = (isWide ? groups : groups.slice(0, 12)).map(
      this.renderGridElement
    );
    return (
      <ElementQueries
        widthBreakpoints={[640, 800]}
        className={classnames(s['grid'], !isWide && s['grid-flex'])}
      >
        {elements}
      </ElementQueries>
    );
  }

  renderGridElement = group => {
    const { username, usericon } = group;

    return (
      <GroupCard
        key={username}
        username={username}
        imageUrl={usericon}
        className={s['group']}
        biData={this.getBiData(group)}
      />
    );
  };

  getBiData(group) {
    const { profileOwnerUser } = this.props;
    const { userId } = group;
    const biData: BIEventData = {
      evid: BiEventType.USERNAME_CLICK,
      typeid: ResourceType.GROUP,
      itemid: userId,
      creatorid: profileOwnerUser.useridUuid,
    };
    return biData;
  }
}

export default withTranslation()(Groups);
